<template>
  <div v-if="isSuperUser" class="is-flex is-justify-content-center recruiter_chooser_container">
    <div>
      <div class="is-flex is-justify-content-space-between">
        <button @click="toggleGeneral('all')" class="button is-danger recruiter">
          בחר את כולם
        </button>
        <button @click="toggleGeneral('none')" class="button is-danger recruiter">
          בטל את כולם
        </button>
      </div>
      <div class="vertical_space"></div>
      <div class="is-flex is-justify-content-center">
        <button
          v-for="recruiter in recruiterList"
          :key="recruiter.id"
          @click="toggleSpecific('toggle', recruiter.id)"
          class="button is-info recruiter"
          :class="{ 'is-outlined': !recruiter.selected }"
          :style="{ 'border-color': recruiter.color, 'background-color': recruiter.selected ? recruiter.color : undefined }"
        >
          {{ recruiter.first_name }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'admin-recruiter-chooser',
  props: {
    isSuperUser: Boolean,
    recruiterList: Array
  },
  methods: {
    toggleGeneral (action) {
      this.$emit('clicked', { action })
    },
    toggleSpecific (action, id) {
      this.$emit('clicked', { action, id })
    }
  }
}
</script>
<style scoped>
  .recruiter_chooser_container {
    margin-top: 20px;
  }
  .recruiter {
    margin: 0 3px;
  }
  .recruiter.is-outlined {
    color: var(--color-text) !important;
  }
  .recruiter:hover {
    background: auto;
  }
  .recruiter:hover.is-outlined {
    background: inherit !important;
  }
</style>
